import axios from 'axios';
import _ from 'lodash';

const getMethods = ['delete', 'get', 'head', 'options'];
const postMethods = ['post', 'put', 'patch'];

function getCsrfMetaTag() {
    return document.querySelector('meta[name=csrf-token]');
}

function setCsrfHeader(config) {
    const csrfMetaTag = getCsrfMetaTag();
    if (csrfMetaTag) {
        _.set(config, "headers['x-csrf-token']", csrfMetaTag.content);
    }
}

function updateCsrfToken(response) {
    const token = _.get(response, "headers['x-csrf-token']");
    if (!token) {
        return;
    }

    const csrfMetaTag = getCsrfMetaTag();
    if (csrfMetaTag) {
        csrfMetaTag.content = token;
    }
}

class AxiosWrapper {
    constructor(options) {
        const defaultOptions = {
            withCredentials: true,
            headers: {},
            xsrfCookieName: '',
        };

        const axiosOption = {...defaultOptions, ...options};
        this.innerAxios = axios.create(axiosOption);

        getMethods.forEach((method) => {
            this[method] = (url, config) =>
                this.request({
                    ...config,
                    method,
                    url,
                });
        });

        postMethods.forEach((method) => {
            this[method] = (url, data, config) =>
                this.request({
                    ...config,
                    method,
                    url,
                    data,
                });
        });
    }

    getUri(config) {
        return this.innerAxios.getUri(config);
    }

    async request(config = {}) {
        let response;
        try {
            if (config.method && postMethods.includes(config.method.toLowerCase())) {
                setCsrfHeader(config);
            }
            response = await this.innerAxios.request(config);
        } catch (err) {
            if (err.response && err.response.status === 419) {
                updateCsrfToken(await this.get('/csrf'));
                setCsrfHeader(config);
                response = await this.innerAxios.request(config);
            } else {
                throw err;
            }
        }
        return response;
    }

    Cancel = axios.Cancel;
    CancelToken = axios.CancelToken;
    isCancel = axios.isCancel;
}

export default new AxiosWrapper();
